import { render } from "./provinceanalysis.vue?vue&type=template&id=514ad7dc&scoped=true"
import script from "./provinceanalysis.vue?vue&type=script&lang=js"
export * from "./provinceanalysis.vue?vue&type=script&lang=js"

import "./provinceanalysis.vue?vue&type=style&index=0&id=514ad7dc&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514ad7dc"]])

export default __exports__